import { io } from "socket.io-client";
const SOCKET_URL = "https://decorassisterp.decorpot.com/"; 
export const socket = io(SOCKET_URL, {
    autoConnect: false,
    transports: ["websocket"],
});
export default socket;
